import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *apolloMutation(mutation, $completion) {
  return yield* this.e6u().o62(mutation).i40('Authorization', 'Bearer ' + (yield* this.f6u($completion))).z5y($completion);
}
function *apolloQuery(query, $completion) {
  return yield* this.e6u().n62(query).i40('Authorization', 'Bearer ' + (yield* this.f6u($completion))).z5y($completion);
}
var KtorQueryPerformerClass;
function KtorQueryPerformer() {
  if (KtorQueryPerformerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KtorQueryPerformer', VOID, VOID, VOID, [1, 0]);
    KtorQueryPerformerClass = $;
  }
  return KtorQueryPerformerClass;
}
//region block: exports
export {
  KtorQueryPerformer as KtorQueryPerformer3enpohylr2sy5,
  apolloMutation as apolloMutation39d5uh404zg7i,
  apolloQuery as apolloQuery3uw4osqu5xxua,
};
//endregion

//# sourceMappingURL=KtorQueryPerformer.mjs.map
